import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { trackEvent, urlWithRelaxedSchemeText, Heading, TextInput, addSchemeIfMissing, colors, Tag } from '@offerzen/pinata'

import { withRouter } from 'react-router-dom'

import SocialBehanceIcon from '@offerzen/zenicon/SocialBehanceIcon'
import SocialBitbucketIcon from '@offerzen/zenicon/SocialBitbucketIcon'
import SocialDribbbleIcon from '@offerzen/zenicon/SocialDribbbleIcon'
import SocialGithubIcon from '@offerzen/zenicon/SocialGithubIcon'
import SocialLinkedinIcon from '@offerzen/zenicon/SocialLinkedinIcon'
import WebsiteIcon from '@offerzen/zenicon/WebsiteIcon'
import rocket from '../../../assets/rocket-ship.svg'

import AccessibleIcon from '../../../CandidateExperience/components/AccessibleIcon'
import MultiUpload from '../../components/MultiUpload'
import Card from '../../components/Card'

import CardFooterNav from '../../components/CardFooterNav'
import { updateProgress as reduxUpdateProgress } from '../../redux/modules/utility'
import { uploadFile as reduxUploadFile, removeFile as reduxRemoveFile } from '../../redux/modules/files'
import { wrapUpCandidate as reduxWrapUpCandidate } from '../../redux/modules/candidate'

import { previousOnboardingUrl } from '../../helpers/onboardingSteps'

import styles from './styles'

const validators = {
  url: urlWithRelaxedSchemeText(),
}

class WrappingUp extends Component {
  componentDidMount() {
    this.props.updateProgress(91)
    trackEvent('onboarding-wrapping-up-accessed')
  }

  updateProfile(data) {
    const completeValues = Object.keys(data).reduce((obj, key) => {
      obj[key] = addSchemeIfMissing(data[key])
      return obj
    }, {})
    return this.props.wrapUpCandidate({
      github_url: completeValues.github_url,
      linkedin_url: completeValues.linkedin_url,
      bitbucket_url: completeValues.bitbucket_url,
      personal_site_url: completeValues.personal_site_url,
      dribbble_url: completeValues.dribbble_url,
      behance_url: completeValues.behance_url,
      onboarding_phase: 'completed',
    })
  }

  render() {
    return (
      <Card title="Links and uploads" imageUrl={rocket} iconWidth={63} width={550}>
        <form onSubmit={this.props.handleSubmit(this.updateProfile.bind(this))}>
          <Heading className={styles.heading}>Where can we see your work?</Heading>
          <p className={styles.subTitle}>Online profiles (optional)</p>

          {this.props.primary_role !== 'design' && (
            <div className={styles.socialNetwork}>
              <span className={styles.socialNetworkIcon}>
                <AccessibleIcon icon={SocialGithubIcon} color={colors.cornflowerBlue} size={14} />
              </span>

              <label htmlFor="github_url" className={styles.socialNetworkName}>
                Github
              </label>

              <Field
                id="github_url"
                name="github_url"
                placeholder="Profile URL"
                validate={validators.url}
                className={styles.socialNetworkInput}
                theme="primary"
                component={TextInput}
              />
            </div>
          )}

          <div className={styles.socialNetwork}>
            <span className={styles.socialNetworkIcon}>
              <AccessibleIcon icon={SocialLinkedinIcon} color={colors.cornflowerBlue} size={14} />
            </span>
            <label htmlFor="linkedin_url" className={styles.socialNetworkName}>
              Linkedin
            </label>

            <Field
              id="linkedin_url"
              name="linkedin_url"
              placeholder="Profile URL"
              className={styles.socialNetworkInput}
              theme="primary"
              validate={validators.url}
              component={TextInput}
            />
          </div>

          {this.props.primary_role !== 'design' && (
            <div className={styles.socialNetwork}>
              <span className={styles.socialNetworkIcon}>
                <AccessibleIcon icon={SocialBitbucketIcon} color={colors.cornflowerBlue} size={14} />
              </span>
              <label htmlFor="bitbucket_url" className={styles.socialNetworkName}>
                Bitbucket
              </label>

              <Field
                id="bitbucket_url"
                name="bitbucket_url"
                placeholder="Profile URL"
                className={styles.socialNetworkInput}
                theme="primary"
                validate={validators.url}
                component={TextInput}
              />
            </div>
          )}

          {this.props.primary_role === 'design' && (
            <div className={styles.socialNetwork}>
              <span className={styles.socialNetworkIcon}>
                <AccessibleIcon icon={SocialDribbbleIcon} color={colors.cornflowerBlue} size={14} />
              </span>
              <label htmlFor="dribbble_url" className={styles.socialNetworkName}>
                Dribbble
              </label>

              <Field
                id="dribbble_url"
                name="dribbble_url"
                placeholder="Profile URL"
                className={styles.socialNetworkInput}
                theme="primary"
                validate={validators.url}
                component={TextInput}
              />
            </div>
          )}

          {this.props.primary_role === 'design' && (
            <div className={styles.socialNetwork}>
              <span className={styles.socialNetworkIcon}>
                <AccessibleIcon icon={SocialBehanceIcon} color={colors.cornflowerBlue} size={14} />
              </span>
              <label htmlFor="behance_url" className={styles.socialNetworkName}>
                Behance
              </label>

              <Field
                id="behance_url"
                name="behance_url"
                placeholder="Profile URL"
                className={styles.socialNetworkInput}
                theme="primary"
                validate={validators.url}
                component={TextInput}
              />
            </div>
          )}

          <div className={styles.socialNetwork}>
            <span className={styles.socialNetworkIcon}>
              <AccessibleIcon icon={WebsiteIcon} color={colors.cornflowerBlue} size={14} />
            </span>
            <label htmlFor="personal_site_url" className={styles.socialNetworkName}>
              Personal website
            </label>
            <Field
              id="personal_site_url"
              name="personal_site_url"
              placeholder="Website address"
              className={styles.socialNetworkInput}
              theme="primary"
              validate={validators.url}
              component={TextInput}
            />
          </div>

          <Heading className={styles.subHeading}>Document upload (optional)</Heading>
          <p className={styles.text}>
            Upload your CV, portfolio, academic transcripts, or other documents that outline your professional experience and education.
          </p>
          <p className={styles.text}>We&apos;ll use these to help you optimise your OfferZen profile.</p>
          <Field
            label="Select a file to upload"
            buttonText="Select file"
            component={MultiUpload}
            className={styles.uploadFile}
            onChange={file => this.props.uploadFile(file.target.files[0])}
            name="linkedin"
          />
          <For each="file" of={this.props.uploaded_files}>
            <Tag
              size="small"
              className={styles.tag}
              key={file.id}
              theme="primary"
              onClear={() => this.props.removeFile(file.id)}
              text={file.filename}
            />
          </For>
          <CardFooterNav
            navigateBack={() => this.props.history.push(previousOnboardingUrl(this.props.location.pathname))}
            loading={this.props.loading}
            theme="primary"
            submitLabel="Next"
            className={styles.footer}
          />
        </form>
      </Card>
    )
  }
}

const mapStateToProps = state => ({
  candidate: state.candidate,
  loading: state.candidate.loading || false,
  uploaded_files: state.candidate.uploaded_files || [],
  primary_role: state.candidate.primary_role,
  initialValues: {
    github_url: state.candidate.github_url,
    linkedin_url: state.candidate.linkedin_url,
    bitbucket_url: state.candidate.bitbucket_url,
    dribbble_url: state.candidate.dribbble_url,
    behance_url: state.candidate.behance_url,
    personal_site_url: state.candidate.personal_site_url,
  },
})

const mapDispatchToProps = dispatch => ({
  uploadFile: file => dispatch(reduxUploadFile(file)),
  removeFile: id => dispatch(reduxRemoveFile(id)),
  wrapUpCandidate: candidate => dispatch(reduxWrapUpCandidate(candidate)),
  updateProgress: progress => dispatch(reduxUpdateProgress(progress)),
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(
    reduxForm({
      form: 'wrappingUp',
    })(WrappingUp),
  ),
)
